import yup from "src/validators/yup.Module";
import { ETipoEventoMDFe } from "../MDFe.Dto";

export const tipoEventoMDFeOptions = [
  { value: "110111", label: "Cancelamento de MDF-e (110111)" },
  { value: "110112", label: "Encerramento de MDF-e (110112)" },
];

export const tipoEventoMDFeDescricoes: Record<number, string> = {
  110111: "Cancelamento de MDF-e",
  110112: "Encerramento de MDF-e",
  110114: "Inclusão de Condutor",
  110115: "Inclusão de DF-e",
  110116: "Registro de Passagem",
  110117: "Registro de Passagem Automático",
  110118: "Alteração de Pagamento do Frete",
  110119: "Inclusão de Pagamento do Frete",
  610110: "Registro de Passagem BRId",
  610111: "Cancelamento Registro de Passagem BRId",
  610112: "Liberação de MDF-e após Transbordo",
};

export const getDescricaoTipoEventoMDFe = (
  tipoEvento?: number | string | null,
  descricaoCustomizada?: string | null
): string => {
  if (
    descricaoCustomizada &&
    descricaoCustomizada.trim() !== "" &&
    isNaN(Number(descricaoCustomizada))
  ) {
    return descricaoCustomizada;
  }
  const cod = Number(tipoEvento);
  if (tipoEventoMDFeDescricoes[cod]) {
    return `${tipoEventoMDFeDescricoes[cod]} (${cod})`;
  }
  return cod ? `Evento (${cod})` : "Evento";
};

export interface MDFeEventoInput {
  mdfeId: number;
  tipoEvento: ETipoEventoMDFe;

  cancelamento?: {
    justificativaCancelamento: string;
  };

  encerramento?: {
    dataEncerramento: string;
    codigoUf?: number;
    codigoMunicipio: number;
  };
}

export interface MDFeEventoOutput {
  id: number;
  mdfeId: number;
  tipoEvento: number;
  tipoEventoDescricao?: string;
  codigoStatusEnvio: number;
  codigoStatusEnvioDescricao?: string;
  codigoStatusResposta?: number;
  descricaoMotivoResposta?: string;
  numeroProtocolo?: string;
  dataHoraEvento?: string;
  cancelamento?: {
    justificativaCancelamento: string;
  };
  encerramento?: {
    dataEncerramento: string;
    codigoUf?: number;
    codigoMunicipio: number;
  };
}

export const EventoCancelamentoSchema = yup.object().shape({
  justificativaCancelamento: yup
    .string()
    .required("Justificativa é obrigatória")
    .min(15, "A justificativa deve ter no mínimo 15 caracteres")
    .max(255, "A justificativa deve ter no máximo 255 caracteres"),
});

export const EventoEncerramentoSchema = yup.object().shape({
  dataEncerramento: yup.string().required("Data de encerramento é obrigatória"),
  codigoMunicipio: yup
    .number()
    .required("Município de encerramento é obrigatório")
    .min(1, "Município de encerramento é obrigatório"),
  nomeMunicipio: yup.string().required("Nome do município é obrigatório"),
});

export type EventoCancelamentoFormType = yup.InferType<
  typeof EventoCancelamentoSchema
>;
export type EventoEncerramentoFormType = yup.InferType<
  typeof EventoEncerramentoSchema
>;
